<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2" style="max-width:400px !important;">

      <!-- Forgot Password v1 -->
      <b-card class="mb-0">

        <!-- Brand logo-->
        <b-link class="brand-logo">
          <img :src="logotipo1" alt="Logo" />
        </b-link>
        <!-- /Brand logo-->

        <b-card-title class="mb-1 text-nowrap lh-1">
          {{$t('¿Has olvidado tu contraseña?')}} 🔒
        </b-card-title>

        <b-card-text class="mb-2 text-center lh-1">
          {{ $t('Ingrese su correo electrónico y le enviaremos instrucciones para restablecer su contraseña') }}
        </b-card-text>

        <!-- form -->
        <b-form @submit.prevent="send" ref="formValidate" class="auth-forgot-password-form mt-2">
          <!-- email -->
            <floating-input name="email" v-model="email" v-bind="emailProps" size="sm" :label="$t('Email')" for="forgot-password-email" :state="!errors.email" :errors="errors">
            </floating-input>
          <!-- submit button -->

          <b-button variant="primary" v-loading="loading" type="submit" class="w-100 text-nowrap" >
            <font-awesome-icon icon="fas fa-paper-plane" />
            {{ $t('Enviar enlace de restablecimiento') }}
          </b-button>
        </b-form>


        <b-card-text class="text-center mt-2">
          <b-link :to="{ name: 'login' }">
            <font-awesome-icon icon="chevron-left" size="lg" />
            {{ $t('Regresar a login') }}
          </b-link>
        </b-card-text>

      </b-card>
    </div>
  </div>
</template>

<script setup>



import logotipo1 from '@images/logos/logo_fondo_claro.png'
import FloatingInput from '@components/forms/FloatingInput.vue';
// storage

import useAppConfigStore from '@/store/app-config';
import useRootStore from '@/store/root';
const app_config = useAppConfigStore();
const root_store = useRootStore();

const {layout} = storeToRefs(app_config);
const {loading} = storeToRefs(root_store);

// i18n
import { useI18n } from 'vue-i18n';
const i18n = useI18n();
// validate
import {useForm} from 'vee-validate';
import { required, email as emailV } from '@validations'

const formulario = ref({
  email: null
})


const {errors,handleSubmit,defineField,setErrors,resetForm} = useForm({
  initialValues:formulario.value,
  validationSchema:{
    email:[emailV,required]
  }
});

const [email,emailProps] = defineField('email');

const send = handleSubmit( (values) => {

  axios.post('/api/auth/recuperar/contrasena',values).then(({data}) => {
    const {mensaje} = data;
    toast.success(mensaje)
    resetForm();
  }).catch(e => {

    if (e.response && e.response.status === 422) {
        setErrors(e.response.data.errors)
    } else {
      console.log(e)
    }

  });

});




</script>

<style lang="scss">
@use '@/assets/scss/vue/pages/page-auth.scss' as *;
</style>